import locale from "localization";
import moment from "moment";
import Validation from "utils/validation.utils";

const initialState = ({ deliveryLog }) => {
  return {
    recipient: {
      name: "recipient",
      value: deliveryLog?.recipient || "station",
      label: locale.deliveryRecipient,
      required: true,
      validations: [Validation.required({ noMessage: true })],
    },
    shiftId: {
      name: "shiftId",
      value: deliveryLog?.shiftId || "",
      label: locale.selectShift,
      placeholder: locale.selectShift,
      required: true,
      validations: [Validation.required()],
      disableAllOption: true,
    },
    date: {
      name: "date",
      value: deliveryLog?.deliveredAt ? moment(deliveryLog?.deliveredAt).toDate() : new Date(),
      label: locale.date,
      required: true,
      placeholder: "DD/MM/YYYY",
      validations: [Validation.required()],
    },
    time: {
      name: "time",
      value: deliveryLog?.deliveredAt ? moment(deliveryLog?.deliveredAt).toDate() : new Date(),
      label: locale.time,
      placeholder: locale.setTime,
      required: true,
      validations: [Validation.required()],
    },
    poReferenceNumber: {
      name: "poReferenceNumber",
      value: deliveryLog?.poReferenceNumber || "",
      label: locale.poReferenceNumber,
      placeholder: "e.g 0003567892",
      required: true,
      maxLength: 30,
      validations: [Validation.required()],
    },
    plateNumber: {
      name: "plateNumber",
      value: deliveryLog?.plateNumber || "",
      label: locale.plateNumber,
      placeholder: "e.g ABC1234",
      required: true,
      maxLength: 15,
      validations: [Validation.required()],
    },
    witness: {
      name: "witness",
      value: (() => {
        if (!deliveryLog?.witnesses?.length) return [];
        const seen = new Set();
        return deliveryLog.witnesses
          .filter(({ name, position }) => {
            const key = `${name}|${position}`;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
          })
          .map(({ name, position }) => ({
            witness: name,
            position,
          }));
      })(),
      label: locale.witness,
      placeholder: locale.enterName,
      required: true,
      validations: [Validation.required(), Validation.requiredArray({ notEmpty: true })],
    },
    productType: {
      name: "productType",
      label: locale.productType,
      placeholder: locale.select,
      value: deliveryLog?.productType || "",
      required: true,
      validations: [Validation.required({ noMessage: true })],
    },
    products: {
      name: "products",
      value: (() => {
        if (!deliveryLog?.products?.length) return [];
        const seen = new Set();
        return deliveryLog.products
          .filter(({ product }) => {
            if (seen.has(product)) return false;
            seen.add(product);
            return true;
          })
          .map(({ product, ...rest }) => {
            let value = {};
            if (deliveryLog?.productType === "fuel") {
              value = {
                quantityBeforeReceivingMm: +rest?.quantityBeforeReceivingCm,
                quantityBeforeReceivingLiter: +rest?.quantityBeforeReceivingL,
                quantityDelivered: +rest?.quantityDeliveredL,
                quantityAfterReceivingMm: +rest?.quantityAfterReceivingCm,
                quantityAfterReceivingLiter: +rest?.quantityAfterReceivingL,
              };
            } else {
              value = {
                quantityBeforeReceiving: +rest?.quantityBeforeReceiving,
                quantityDelivered: +rest?.quantityDelivered,
                quantityAfterReceiving: +rest?.quantityAfterReceiving,
              };
            }

            return {
              product: product,
              ...value,
            };
          });
      })(),
      required: true,
      validations: [Validation.required(), Validation.requiredArray({ notEmpty: true })],
    },
    cashier: {
      name: "cashier",
      value: "",
      required: false,
      validations: [],
    },
  };
};

export default initialState;
